import { createVuetify } from 'vuetify'
import { defineNuxtPlugin } from 'nuxt/app'
import { md3 } from 'vuetify/blueprints'
import { VDateInput } from 'vuetify/labs/VDateInput'

import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

import * as components from 'vuetify/components' // get all components
import * as directives from 'vuetify/directives' // get all directives

export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({
   ssr: true,
   icons: {
     defaultSet: 'mdi',
   },
   theme: {
      defaultTheme: 'light'
   },
   components:{
      ...components,
      VDateInput,
    },
   directives,
   blueprint: md3,
  })
  nuxtApp.vueApp.use(vuetify)
})